import { z } from 'zod';
import { playerIdNameParser } from './utils/playerInboundUtils';
const SetBadBeatJackpotAmountInboundSchema = z
    .object({
    powerPlayerWinnableAmount: z.number(),
    nonPowerPlayerWinnableAmount: z.number(),
    lastWinner: z.string().transform(playerIdNameParser).optional()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'set_bad_beat_jackpot_amount',
    ...rest
}));
export const SET_BAD_BEAT_JACKPOT_AMOUNT_PAYLOAD_DEFINITION = {
    zodSchema: SetBadBeatJackpotAmountInboundSchema
};
